export default __webpack_public_path__ + "static/web20221025-accd0f390c6920f12d04149d3dc59399.png";